import { emailRex } from "commons/constants";

export const  verifyEmail = (value) => {
 
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  };